import ActivitiesIcon from '../../stories/Icons/Amenities/ActivitiesIcon';
import AirportTransportIcon from '../../stories/Icons/Amenities/AirportTransportIcon';
// import AirportTransportIcon from '../../stories/Icons/';
import BanquetHallIcon from '../../stories/Icons/Amenities/BanquetHallIcon';
import Bathroom from '../../stories/Icons/Amenities/BathroomIcon';
import BellboyService from '../../stories/Icons/Amenities/BellboyServiceIcon';
import CctvIcon from '../../stories/Icons/Amenities/CctvIcon';
import CleanRoomIcon from '../../stories/Icons/Amenities/CleanRoomIcon';
import ConferenceRoomIcon from '../../stories/Icons/Amenities/ConferenceRoomIcon';
import DailyHousekeeping from '../../stories/Icons/Amenities/DailyHousekeepingIcon';
import DailyNewspaper from '../../stories/Icons/Amenities/DailyNewspapeIcon';
import DoctorOnCall from '../../stories/Icons/Amenities/DoctorOnCallIcon';
import ElectricSmokeDetector from '../../stories/Icons/Amenities/ElectricSmokeDetectorIcon';
import Elevator from '../../stories/Icons/Amenities/ElevatorIcon';
import FreeParking from '../../stories/Icons/Amenities/FreeParkingIcon';
import HouseKeepingIcon from '../../stories/Icons/Amenities/HouseKeepingIcon';
import InternationalPlug from '../../stories/Icons/Amenities/InternationalPlugIcon';
import IronAndIroningBoard from '../../stories/Icons/Amenities/IronAndIroningBoard';
import MiniRefrigirator from '../../stories/Icons/Amenities/MiniRefrigiratorIcon';
import MoneyExchange from '../../stories/Icons/Amenities/MoneyExchangeIcon';
import ParkingIcon from '../../stories/Icons/Amenities/ParkingIcon';
import Photocopy from '../../stories/Icons/Amenities/PhotocopyIcon';
import PowerBackupIcon from '../../stories/Icons/Amenities/PowerBackupIcon';
import RestaurantIcon from '../../stories/Icons/Amenities/RestaurantIcon';
import RoomServiceIcon from '../../stories/Icons/Amenities/RoomServiceIcon';
import Safe from '../../stories/Icons/Amenities/SafeIcon';
import Security from '../../stories/Icons/Amenities/SecurityIcon';
import SpaIcon from '../../stories/Icons/Amenities/SpaIcon';
import SpeciallyAbledAssistance from '../../stories/Icons/Amenities/SpeciallyAbledAssistanceIcon';
import SwimmingIcon from '../../stories/Icons/Amenities/SwimmingIcon';
import Telephone from '../../stories/Icons/Amenities/TelephoneIcon';
import TvWithCable from '../../stories/Icons/Amenities/TvWithCableIcon';
import Umbrella from '../../stories/Icons/Amenities/UmbrellaIcon';
import WheelchairsAvailable from '../../stories/Icons/Amenities/WheelchairsAvailableIcon';
import WifiIcon from '../../stories/Icons/Amenities/WifiIcon';
import LaundryIcon from '../../stories/Icons/LaundryIcon';
import RoundedCheckbox from '../../stories/Icons/RoundedCheckbox';
import HappyWifiIcon from '@stencil/icons/src/HappyWifiIcon/HappyWifiIcon';
import HappyBedIcon from '@stencil/icons/src/HappyBedIcon/HappyBedIcon';
import HappyCleanRoomBathroomIcon from '@stencil/icons/src/HappyCleanRoomBathroomIcon/HappyCleanRoomBathroomIcon';
import HappyTvandAcIcon from '@stencil/icons/src/HappyTvandAcIcon/HappyTvandAcIcon';
import HappyTopRatedByCustomersIcon from '@stencil/icons/src/HappyTopRatedByCustomersIcon/HappyTopRatedByCustomersIcon';
import HappyFreeWifiIcon from '@stencil/icons/src/HappyFreeWifiIcon/HappyFreeWifiIcon';

import useIsClient from '@stencil/hotels-hooks/src/useIsClient';

const AmenitiesIconSelector = ({
  name = '',
  styleProps,
}: {
  name: string;
  styleProps?: {
    [k: string]: string; // better typescript – 🐨 css properties
  };
}) => {
  const isClient = useIsClient();
  if (!isClient) return <span style={{...styleProps}} />;
  if (!name) return <RoundedCheckbox {...styleProps} />;

  switch (name.toLowerCase()) {
    case 'umbrella':
    case 'umbrellas':
      return <Umbrella {...styleProps} />;
    case 'international plug':
      return <InternationalPlug {...styleProps} />;
    case 'mini refrigerator':
    case 'refrigerator':
      return <MiniRefrigirator {...styleProps} />;
    case 'security':
      return <Security {...styleProps} />;
    case 'free parking area':
    case 'free parking':
      return <FreeParking {...styleProps} />;
    case 'telephone':
      return <Telephone {...styleProps} />;
    case 'doctor on call':
      return <DoctorOnCall {...styleProps} />;
    case 'money exchange facility':
    case 'currency exchange':
      return <MoneyExchange {...styleProps} />;
    case 'elevator/lift':
      return <Elevator {...styleProps} />;
    case 'daily housekeeping':
      return <DailyHousekeeping {...styleProps} />;
    case 'bathroom':
      return <Bathroom {...styleProps} />;
    case 'private safe box':
      return <Safe {...styleProps} />;
    case 'electronic smoke detector':
    case 'smoke detector':
      return <ElectricSmokeDetector {...styleProps} />;
    case 'photocopying':
      return <Photocopy {...styleProps} />;
    case 'daily newspaper':
    case 'newspaper':
      return <DailyNewspaper {...styleProps} />;
    case 'iron and ironing board':
    case 'iron/ironing board':
      return <IronAndIroningBoard {...styleProps} />;
    case 'bellboy service':
      return <BellboyService {...styleProps} />;
    case 'wheelchairs available':
    case 'wheelchair accessible':
      return <WheelchairsAvailable {...styleProps} />;
    case 'tv with cable channels':
    case 'tv':
      return <TvWithCable {...styleProps} />;
    case 'specially-abled assistance':
      return <SpeciallyAbledAssistance {...styleProps} />;
    case 'room service':
      return <RoomServiceIcon {...styleProps} />;
    case 'dining area':
    case 'restaurant':
    case 'restaurant/coffee Shop':
    case 'coffee shop':
    case 'kitchen':
    case 'kitchenette':
      return <RestaurantIcon {...styleProps} />;
    case 'parking facility':
    case 'parking':
    case 'free parking area':
    case 'free parking':
      return <ParkingIcon {...styleProps} />;
    case 'free wifi':
    case 'free wi-fi':
    case 'free internet':
      return <HappyWifiIcon {...styleProps} />;
    case 'laundry service':
    case 'caretaker':
      return <HouseKeepingIcon {...styleProps} />;
    case 'banquet hall':
      return <BanquetHallIcon {...styleProps} />;
    case 'cctv':
    case 'cctv surveillance':
      return <CctvIcon {...styleProps} />;
    case 'clean room':
      return <CleanRoomIcon {...styleProps} />;
    case 'power backup':
      return <PowerBackupIcon {...styleProps} />;
    case 'conference room':
      return <ConferenceRoomIcon {...styleProps} />;
    case 'laundry service':
    case 'laundry service (at a charge)':
      return <LaundryIcon {...styleProps} />;
    case 'spa':
      return <SpaIcon {...styleProps} />;
    case 'outdoor activities':
    case 'outdoor sports':
      return <ActivitiesIcon {...styleProps} />;
    case 'swimming':
    case 'swimming pool':
      return <SwimmingIcon {...styleProps} />;
    case 'travel assistance':
    case 'ticket/tour assistance':
    case 'airport transfer (surcharge)':
    case 'paid airport transfers':
      return <AirportTransportIcon {...styleProps} />;
    case 'gostays-clean rooms & bathrooms':
      return <HappyCleanRoomBathroomIcon {...styleProps} />;
    case 'gostays-tv & ac':
      return <HappyTvandAcIcon {...styleProps} />;
    case 'gostays-top rated by our customers':
      return <HappyTopRatedByCustomersIcon {...styleProps} />;
    case 'gostays-free wifi':
      return <HappyFreeWifiIcon {...styleProps} />;
    default:
      return <RoundedCheckbox {...styleProps} />;
  }
};

export default AmenitiesIconSelector;
